import { Download } from "lucide-react";

export function CsvButton({ onClick }: { onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      title="Scarica questi dati in CSV"
      className="flex items-center gap-1 rounded-md border border-slate-200 bg-white px-2 py-1 text-xs text-slate-600 hover:bg-slate-50"
    >
      <Download className="w-3.5 h-3.5" aria-hidden />
      CSV
    </button>
  );
}
